import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Button,
  Table,
} from "reactstrap";
import { connect } from "react-redux";

function ModalErrosList(props) {
  const { isOpen, toggle, errors, typeImport } = props;

  const [isLoading, setIsloading] = useState(false);

  const [modalBackdrop, setModalBackdrop] = useState(false);

  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }
  function hasValidProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  return (
    <>
      {" "}
      <Modal
        isOpen={isOpen}
        toggle={() => {
          toggleBackdrop();
        }}
        autoFocus={true}
        centered={true}
        size="lg"
      >
        <ModalHeader toggle={toggle}>Lista de erros</ModalHeader>
        <ModalBody>
          <div style={{ maxHeight: "250px", overflowY: "auto" }}>
            <Table className="table mb-0" style={{ minWidth: "600px" }}>
              <thead
                className="table-light"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  backgroundColor: "#f8f9fa",
                }}
              >
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Linha</th>
                  <th style={{ verticalAlign: "middle" }}>Título</th>
                  {typeImport !== "delete" && (
                    <th style={{ verticalAlign: "middle" }}>
                      Data da Programação
                    </th>
                  )}

                  {typeImport !== "create" && (
                    <th style={{ verticalAlign: "middle" }}>
                      ID Agenda
                      <div style={{ fontSize: "12px", color: "#666" }}>
                        O(s) ID(s) abaixo não estão cadastrados no evento
                      </div>
                    </th>
                  )}
                  {typeImport !== "delete" && (
                    <th style={{ verticalAlign: "middle" }}>
                      ID Palestrantes
                      <div style={{ fontSize: "12px", color: "#666" }}>
                        O(s) ID(s) abaixo não estão cadastrados no evento
                      </div>
                    </th>
                  )}
                </tr>
              </thead>

              <tbody>
                {errors &&
                  errors.length > 0 &&
                  errors.map((e, i) => (
                    <tr key={i}>
                      <td>{e?.index + 2}</td>
                      <td>
                        {hasValidProperty(e, "title")
                          ? "A coluna título é obrigatória."
                          : ""}
                      </td>
                      {typeImport !== "delete" && (
                        <td>
                          {hasValidProperty(e, "startDate")
                            ? "A coluna DataDaProgramacao é obrigatória."
                            : ""}
                        </td>
                      )}
                      {typeImport !== "create" && (
                        <td>
                          {hasValidProperty(e, "id")
                            ? e?.invalidId
                              ? e?.invalidId
                              : "A coluna AgendaID é obrigatória."
                            : ""}
                        </td>
                      )}
                      {typeImport !== "delete" && (
                        <td>{e?.invalidPalestrantes?.join(",")}</td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>

          <Row
            style={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "#fff",
              padding: "1rem 0",
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              zIndex: 10,
              borderTop: "1px solid #dee2e6",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(ModalErrosList);
